import { render, staticRenderFns } from "./Birthdays.vue?vue&type=template&id=0c86fa6b&scoped=true"
import script from "./Birthdays.vue?vue&type=script&lang=js"
export * from "./Birthdays.vue?vue&type=script&lang=js"
import style0 from "./Birthdays.vue?vue&type=style&index=0&id=0c86fa6b&prod&lang=scss"
import style1 from "../../styles/list.scss?vue&type=style&index=1&id=0c86fa6b&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c86fa6b",
  null
  
)

export default component.exports